import { render, staticRenderFns } from "./FlagSelect.vue?vue&type=template&id=72e16d36&scoped=true"
import script from "./FlagSelect.vue?vue&type=script&lang=ts"
export * from "./FlagSelect.vue?vue&type=script&lang=ts"
import style0 from "./FlagSelect.vue?vue&type=style&index=0&id=72e16d36&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e16d36",
  null
  
)

export default component.exports